import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    orderList: () => {
        return HTTP.get('/orderwebpage', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    orderDetail: (id) => {
        return HTTP.get('/orderwebpage/orderDetail/'+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addTrackNumber: (id,data) => {
        return HTTP.post('/orderwebpage/add_track_number/'+id,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    confirmSlip: (id) => {
        return HTTP.post('/orderwebpage/checkSlip/'+id,null, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}